import React, { ReactNode } from 'react';
import { Maybe } from 'graphql/jsutils/Maybe';
import styled from 'styled-components';
import {
    Container,
    Box,
    MaestroBaseProps,
    BoxProps,
    spacing,
} from '@landr/maestro';
import Wrapper from 'components/CommonUi/Wrapper';
import { useGradientContext } from 'controllers/GradientController/GradientController';
import useMountEffect from 'hooks/useMountEffect';

interface PageHeaderProps extends MaestroBaseProps<BoxProps> {
    imgUrl?: Maybe<string>;
}

const BoxStyled = styled(Box)`
    position: relative;
    padding-bottom: ${spacing('jb')};

    ${({ theme }): string => theme.breakpoint('md')`
        padding-bottom: ${spacing('xxl')};
    `}
`;

export const PageHeader: React.FC<PageHeaderProps> = ({ children }) => {
    const { updateGradient } = useGradientContext();

    useMountEffect(() => {
        updateGradient();
    });

    return (
        <BoxStyled>
            <Wrapper>
                <Container>{children}</Container>
            </Wrapper>
        </BoxStyled>
    );
};

interface PageBodyProps {
    children: ReactNode;
}

export const PageBody = React.forwardRef<HTMLDivElement, PageBodyProps>(
    ({ children }, ref) => {
        return (
            <Wrapper>
                <Container ref={ref} style={{ scrollMargin: '48px' }}>
                    {children}
                </Container>
            </Wrapper>
        );
    },
);
